define('module/filter',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($,_,Cnf, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub();
        
        this.options={
            selector:{
                form:'form.filter-form',
                result:'.filter-result-wrapper',
                reset:'.reset'
            },
            data:{
                active:'active'
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initForm();
        };
        
        this.initOptions=function()
        {
            this.oForm={};
            this.$form=Cnf.$app.find(this.options.selector.form);
            this.iForm=this.$form.length;
            this.$result=Cnf.$app.find(this.options.selector.result);
        };
        
        this.initForm=function()
        {
            if(this.iForm<=0) {
                return;
            }
            
            var defaultData,
                    $result;
            
            for(var i=0;i<this.iForm;i++) {
                defaultData={
                    env:window.cnf.current.env,
                    lang:window.cnf.current.lang
                };
                
                _.each(this.$form.eq(i).find('[type="hidden"]'), _.bind(function(defaultData,item) {
                    defaultData[item.name]=item.value;
                }, this, defaultData));
                
                $result=this.$result;
                if(this.$form.eq(i).find('[name="element_id"]').length>0) {
                    $result=Cnf.$app.find('#' + this.$form.eq(i).find('[name="element_id"]').val());
                }
                
                this.oForm[i]={
                    defaultData:defaultData,
                    data:_.extend({}, defaultData),
                    $form:this.$form.eq(i),
                    $select:this.$form.eq(i).find('select'),
                    $reset:this.$form.eq(i).find(this.options.selector.reset),
                    $result:$result,
                    slider_on_mobile:("1"===this.$form.eq(i).find('[name="slider_on_mobile"]').val() ? true : false),
                    slider_index:this.$form.eq(i).find('[name="slider_on_mobile"]').data('index'),
                    busy:false,
                    lock:false,
                    ajax:null,
                    filtered:{}
                };
                
                //add listener
                this.oForm[i].$select.on('change', _.bind(this.select,this,i));
                this.oForm[i].$reset.on(Cnf.click, _.bind(this.reset,this,i));
            }
        };
        
        this.select=function(index, ev)
        {
            if(true===this.oForm[index].lock) {
                return;
            }
            
            this.oForm[index].data[ev.currentTarget.name]=ev.currentTarget.value;
            this.oForm[index].filtered[ev.currentTarget.name]=((ev.currentTarget.selectedIndex>0) ? 1 : -1);
            
            this.send(index);
        };
        
        this.reset=function(index)
        {
            if(false===this.hasFiltered(index)) {
                return;
            }
            
            this.oForm[index].lock=true;
            this.oForm[index].data=_.extend({}, this.oForm[index].defaultData);
            _.each(this.oForm[index].$select, function(item) {
                        $(item).prop('selectedIndex', 0);
            });
            this.oForm[index].filtered={};
            
            this.send(index);
        };
        
        this.hasFiltered=function(index)
        {
            return _.some(this.oForm[index].filtered, function(item){
                return (item>0);
            });
        };
        
        this.send=function(index)
        {
            if(true===this.oForm[index].busy) {
                this.oForm[index].ajax.abort();
            }
            this.oForm[index].busy=true;
            this.oForm[index].$result.attr('data-pending','true');
            
            this.oForm[index].ajax=$.ajax({
                url:window.cnf.host + window.cnf.api,
                dataType:'json',
                method:'post',
                data:_.extend({}, {action:window.cnf.action.filter}, this.oForm[index].data),
                complete:_.bind(function(index,xhr) {
                    switch(xhr.status) {
                        case 200:
                            this.oForm[index].$result.attr('data-pending','hide');
                            _.delay(_.bind(function() {
                                if(true===this.oForm[index].slider_on_mobile) {
                                    oPubsub.trigger(Pubsub.DESTROY_FLICKITY_BY_ID, {id:this.oForm[index].slider_index})
                                }
                                this.oForm[index].$result.height(this.oForm[index].$result.height());
                                this.oForm[index].$result.children().remove();
                                $(xhr.responseJSON.msg).appendTo(this.oForm[index].$result);
                                this.oForm[index].$result.height('auto');
                                this.oForm[index].$result.attr('data-pending','false');
                                if(true===this.oForm[index].slider_on_mobile) {
                                    oPubsub.trigger(Pubsub.UPDATE_FLICKITY_BY_ID, {id:this.oForm[index].slider_index})
                                }
                                //trigger lazyload
                                $(window).trigger('dispatchLazyload', {el: this.oForm[index].$result[0]});
                            },this),300);
                            
                            break;
                            
                        default:
                            this.oForm[index].$result.attr('data-pending','false');
                            break;
                    }
                    
                    //reset to default
                    this.oForm[index].busy=false;
                    this.oForm[index].lock=false;
                    this.oForm[index].$reset.attr('data-active', (true===this.hasFiltered(index)) ? 'true' : 'false');
                }, this, index)
            });
        };
        
        this.init();
    };
});
